import { useForm } from 'react-hook-form';
import { z } from 'zod';
import { zodResolver } from '@hookform/resolvers/zod';
import { getFieldConfigs } from '../common/getFieldConfigs';

export const useFormValidation = (fields: string[], intl: any) => {
    const schema = z.object(
        Object.fromEntries(fields.map(field => [field, getFieldConfigs(intl)[field].getValidation(intl)])),
    );

    return useForm({
        resolver: zodResolver(schema),
        mode: 'onBlur',
    });
};
